var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"maintitle"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1),_c('div',{staticClass:"main_content"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.explainContent)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }